const TRACKING_NAMES = {
    SUBCATEGORY_PAGE: 'Sub Category',
    PRO_SUBCATEGORY_PAGE: 'Pro Sub Category',
    SEARCH_PAGE: 'Search'
};

const LISTINGS_TYPES = {
    SEARCH: 'Search'
};

const OTHER_SUBCATEGORY_IDS = [
    '9', '20', '31', '38', '97', '117', '118', '120', '121', '122', '123', '137', '240', '457'
];

module.exports = {
    TRACKING_NAMES,
    LISTINGS_TYPES,
    OTHER_SUBCATEGORY_IDS
};
